<h3>REGISTRATION</h3>

<p>
	The fee of CIFRIS23 is
</p>
<ol>
	<li>190.00 euros, regular fee;</li>
	<li>170.00 euros, fee for members of Unione Matematica Italiana, IEEE Computer Society, IEEE Information Theory
		Society;</li>
	<li>120.00 euros, young fee (less than 30 year old on 1 January 2023);</li>
	<li>120.00 euros, fee for members of De Cifris (“ordinario”, ”benemerito” or “fondatore”);</li>
	<li>70.00 euros, fee for members of De Cifris “socio giovane” (young members);</li>
	<li>40.00 euros, companion fee.</li>
</ol>
<p> The fee (except for the <em>companion fee</em>) covers: </p>
<ul>
	<li>free entrance to the main conference room and to the workshops rooms;</li>
	<li>all coffee breaks and all lunches (14 and 15 December);</li>
	<li>social dinner (14 December);</li>
	<li>an electronic copy of the “Proceedings";</li>
</ul>
<p>
	PS: membership of De Cifris costs 20 euros "regular" and 5 euros "young", but it is reserved to EU citizens.
</p>
<p style="color: red;">
	To register, please send an email to <a href="mailto:cifris23@decifris.it">cifris23&#64;decifris.it</a>. <br>
	In the email please specify whether you pay yourself or your company/institution pays for you (in that case, please
	send us its fiscal data). <br>
</p>
<p style="color: red;">
	<b>Registration Deadline 3 December 2023.</b>
</p>

<hr>

<h4>PAYMENT</h4>

<form id="payForm" class="form" method="post" (ngSubmit)="checkAndPay()">
	<label> Fee </label>
	<div>
		<input type="radio" id="regular" name="fee" value="19000" (click)=setFee($event) checked="checked">
		<label for="regular"> Regular </label><br>

		<input type="radio" id="scientific_memebers" name="fee" value="17000" (click)=setFee($event)>
		<label for="scientific_memebers">
			Members of Unione Matematica Italiana, IEEE Computer Society, IEEE Information Theory Society
		</label><br>

		<input type="radio" id="young" name="fee" value="12000" (click)=setFee($event)>
		<label for="young"> Young </label><br>

		<input type="radio" id="member" name="fee" value="12000" (click)=setFee($event)>
		<label for="member">
			Member of De Cifris (“ordinario”, ”benemerito” or “fondatore”)
		</label><br>

		<input type="radio" id="member_young" name="fee" value="7000" (click)=setFee($event)>
		<label for="member_young">
			Member of De Cifris (“socio giovane”)
		</label><br>

		<input type="radio" id="companion" name="fee" value="4000" (click)=setFee($event)>
		<label for="companion"> Companion </label>
	</div>

	<!-- Hidden input -->
	<input type="hidden" id="alias" name="alias" value={{ALIAS}}>
	<input type="hidden" id="importo" name="importo">
	<input type="hidden" id="divisa" name="divisa" value={{DIVISA}}>
	<input type="hidden" id="codTrans" name="codTrans">
	<input type="hidden" id="url" name="url">
	<input type="hidden" id="url_back" name="url_back">
	<input type="hidden" id="mac" name="mac">
	<input type="hidden" id="mail" name="mail">
	<input type="hidden" id="languageId" name="languageId" value="ENG">
	<input type="hidden" id="descrizione" name="descrizione">
	<input type="hidden" id="Note1" name="Note1" value="Enrollment for CIFRIS23.">
	<input type="hidden" id="nome" name="nome">
	<input type="hidden" id="cognome" name="cognome">

	<hr><!---------------------------------------------------------------->

	<p style="font-weight: bold;">
		Total: € {{fee/100}}.00
	</p>

	<!-- Submit input -->
	<!--
		<input type="submit" value="Pay Now">
		-->

	<p class="footnote">
		De Componendis Cifris kindly requests your consent for the processing of your personal data provided in the
		payment form. Your data will be sent by Nexi to us after your payment. The Association declares that this
		information is essential for event planning, communication purposes, and addressing any special requests.
		Your personal data will be securely deleted upon the conclusion of the event, unless you have a longer
		collaboration with De Componendis Cifris, such as being one of our members.
	</p>
</form>